import { css } from "styled-components";

export const Elements = css`
	.container {
		background-color: #fff;
		border-radius: 4px;
		box-shadow: 1px 1px 4px gray;
		margin: 10px auto 10px;
		padding: 10px;
		max-width: 800px;
		width: 100%;
	}
	.subText {
		font-size: 0.8rem;
		color: gray;
	}
`;
